import { render, staticRenderFns } from "./deliveryCharge.vue?vue&type=template&id=39a266f0&scoped=true"
import script from "./deliveryCharge.vue?vue&type=script&lang=ts"
export * from "./deliveryCharge.vue?vue&type=script&lang=ts"
import style0 from "./deliveryCharge.vue?vue&type=style&index=0&id=39a266f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a266f0",
  null
  
)

export default component.exports